import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IContenidoReformaPensionesEntry, IContenidoReformaPensionesResponse } from '@interfaces/capital-play-content.interface';
import { Util } from '@shared/common/utils/util';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

const MAX_ENTRIES = 12;

@Injectable({
  providedIn: 'root'
})
export class CapitalPlayContentService {

  private entriesPromise: Promise<IContenidoReformaPensionesEntry[]> | null = null;

  constructor(private readonly http: HttpClient, private readonly util: Util) { }

  async getReformaEntries(): Promise<IContenidoReformaPensionesEntry[]> {
    if (this.entriesPromise) {
      return this.entriesPromise;
    }

    const token = await this.util.getIdToken();
    const url = `${environment.BASE_BACKEND}/client/contenido-reforma-pensiones`;
    const headers = this.util.getHeaders(token);

    this.entriesPromise = firstValueFrom(
      this.http.get<IContenidoReformaPensionesResponse>(url, { headers })
    )
      .then(response => (response?.entries ?? []).slice(0, MAX_ENTRIES))
      .finally(() => {
        this.entriesPromise = null;
      });

    return this.entriesPromise;
  }
}
